import React from 'react'
import { BoxButtonsContainer, BoxContentContainer, styles } from './styles'
import CustomModal from '../CustomModal'
import LogoutSessionSVG from 'assets/svg/LogoutSessionSVG'
import CustomText from 'components/atoms/CustomText'
import Button from 'components/atoms/Button'
import { useDispatch } from 'react-redux'
import { logOut } from 'store/auth/thunks'
import useNavigation from 'hooks/useNavigation'
import setShowModal from 'store/modals/actions'
import { useAppSelector } from 'hooks/redux'

interface Props {
  isOpen: boolean
}

const LogoutModal: React.FC<Props> = ({ isOpen }) => {
  const { onNavigate } = useNavigation()
  const dispatch = useDispatch()
  const { isLogoutRequired } = useAppSelector(state => state.authV2)
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={() => (isLogoutRequired ? null : dispatch(setShowModal('')))}
      title="Cerrar sesión"
      icon={<LogoutSessionSVG active={false} />}
      showCloseButton={!isLogoutRequired}
    >
      <BoxContentContainer>
        {isLogoutRequired
          ? (
            <CustomText size="medium">
              Se actualizó tu cuenta principal. Cerrá sesión y volvé a iniciar
              para aplicar los cambios.
            </CustomText>
            )
          : (
            <CustomText size="mmbig">
              {'¿Estás seguro que  querés\n cerrar sesión?'}
            </CustomText>
            )}

        <BoxButtonsContainer id="modal-logout">
          <Button
            disabled={false}
            customStyle={styles.button}
            onPress={() => dispatch(logOut(onNavigate))}
          >
            Cerrar sesión
          </Button>
          {!isLogoutRequired && (
            <Button
              disabled={false}
              secondary
              customStyle={styles.button}
              onPress={() => dispatch(setShowModal(''))}
            >
              Cancelar
            </Button>
          )}
        </BoxButtonsContainer>
      </BoxContentContainer>
    </CustomModal>
  )
}

export default LogoutModal
